import * as React from 'react';

interface SduiContentProps {
  name: string;
  local?: boolean;
}

export class SduiContent extends React.Component<SduiContentProps> {
  public render() {
    return this.props.children || null;
  }
}
